import { Group, Text, UnstyledButton } from '@mantine/core';
import { CoreValueBadge } from './CoreValueBadge';
import { WorkspaceCoreValue } from '@/common/types/databaseTypes';
import { useTranslation } from 'react-i18next';

interface CoreValueSelectorProps {
    title: string;
    isPositive: boolean;
    editable?: boolean;
    selectedValues: string[];
    disabledValues: string[];
    coreValues: WorkspaceCoreValue[];
    onValueChange: (selectedIds: string[]) => void;
}

export const CoreValueSelector = ({
    title,
    isPositive,
    editable = true,
    selectedValues,
    disabledValues,
    coreValues,
    onValueChange,
}: CoreValueSelectorProps) => {
    const { t } = useTranslation('feedback');
    const colorName = isPositive ? 'blue' : 'red';

    return (
        <>
            <Group gap="xs">
                <Text size="sm" fw={600}>
                    {title}
                </Text>
                <Text size="xs" c="dimmed">
                    ({t('coreValue.allowMultiple')})
                </Text>
                {/* <ActionIcon variant="default" color="gray" size="xs" c="gray">
                    <IconSettings size={12} />
                </ActionIcon> */}
            </Group>
            <Group gap={4}>
                {coreValues.map(coreValue => (
                    <UnstyledButton
                        key={coreValue.id}
                        onClick={() => {
                            if (!editable) return;

                            const valueId = coreValue.id.toString();
                            if (disabledValues.includes(valueId)) return;

                            if (selectedValues.includes(valueId)) {
                                onValueChange(
                                    selectedValues.filter(id => id !== valueId)
                                );
                            } else {
                                onValueChange([...selectedValues, valueId]);
                            }
                        }}
                    >
                        <CoreValueBadge
                            label={coreValue.name}
                            colorName={
                                selectedValues.includes(coreValue.id.toString())
                                    ? colorName
                                    : 'gray'
                            }
                            isSelected={selectedValues.includes(
                                coreValue.id.toString()
                            )}
                            disabled={disabledValues.includes(
                                coreValue.id.toString()
                            )}
                            clickable={editable}
                        />
                    </UnstyledButton>
                ))}
            </Group>
        </>
    );
};
